import { Component } from "react";

import Button from "@material-ui/core/Button";
import { DatePicker } from "@material-ui/pickers/DatePicker";
import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CardActions from "@material-ui/core/CardActions";

import CurrencyFormater from "../../../shared/ui/Currency.Input";
import MenuItem from "@material-ui/core/MenuItem";

import { orange500, blue500 } from "material-ui/styles/colors";
import PropTypes from "prop-types";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { accountingConnector } from "../../../services/accounting/connector";
import { compose } from "redux";

class AccountingRegisteringMarketplaceComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      PaymentId: "",
      TotalRemainingPrincipal: "",
      Penalty: "",
      Interest: "",
      Principal: "",
      OriginatorCreditId: "",
      Number: "",
      BankReceiveDate: new Date(),
      matchStyle: this.styles.matchedStyle,
      matchText: "",
      OriginatorId: "",
      isDialogOpen: false,
      CreditEnded: false,
    };
  }

  styles = {
    errorStyle: {
      color: orange500,
    },
    matchedStyle: {
      color: blue500,
    },
  };

  componentDidMount() {
    this.props.getOriginators();
  }

  registerPayment = () => {
    let principal = this.state.Principal || 0;
    let interest = this.state.Interest || 0;
    let penalty = this.state.Penalty || 0;
    let totalRemainingPrincipal = this.state.TotalRemainingPrincipal || 0;
    this.props.registerMPLRepayment(
      this.state.OriginatorCreditId,
      this.state.Number,
      this.state.BankReceiveDate,
      principal,
      interest,
      penalty,
      totalRemainingPrincipal,
      this.state.OriginatorId,
      this.state.CreditEnded,
    );
    this.setState({
      OCR: "",
      Number: "",
      BankReceiveDate: new Date(),
      PaymentId: "",
      TotalRemainingPrincipal: "",
      Penalty: "",
      Interest: "",
      Principal: "",
      OriginatorId: "",
      CreditEnded: false,
      OriginatorCreditId: "",
    });
  };

  render() {
    let wrapperStyle = {
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap",
    };
    let halfItemStyle = {
      minWidth: "450px",
      width: "50%",
      padding: "10px",
      boxSizing: "border-box",
    };

    let originators = this.props.marketplace.originators.data.map(
      (originator, index) => {
        return (
          <MenuItem value={originator.Id} key={"orig-dropdown-" + index}>
            {originator.Name}
          </MenuItem>
        );
      },
    );

    return (
      <div>
        <div className="accounting-layout body-height" style={wrapperStyle}>
          <div style={halfItemStyle}>
            <Card style={{ height: "100%" }}>
              <CardHeader title="Register new mpl payment" subheader={" "} />
              <CardContent>
                <TextField
                  size="small"
                  variant="outlined"
                  select
                  id="Originator-field"
                  label="Originator"
                  value={this.state.OriginatorId}
                  onChange={this.changeOriginator}
                  fullWidth={true}
                >
                  {originators}
                </TextField>

                <br />
                <TextField
                  size="small"
                  variant="outlined"
                  value={this.state.OriginatorCreditId}
                  onChange={this.changeOriginatorCreditId}
                  label="Originator Credit Id"
                  fullWidth={true}
                  errorText={this.state.matchText}
                  errorStyle={this.state.matchStyle}
                />
                <br />
                <TextField
                  size="small"
                  variant="outlined"
                  value={this.state.Number}
                  onChange={this.changeNumber}
                  fullWidth={true}
                  label="Number of the repayment"
                  type="number"
                />

                <br />
                <DatePicker
                  inputVariant="outlined"
                  className="small-datepicker"
                  value={this.state.BankReceiveDate}
                  onChange={this.changeBankReceiveDate}
                  fullWidth={true}
                  label="Bank registered date"
                />
                <br />
                <CurrencyFormater
                  value={this.state.Principal}
                  onChange={this.changePrincipal}
                  fullWidth={true}
                  label="Principal"
                />
                <br />
                <CurrencyFormater
                  value={this.state.Interest}
                  onChange={this.changeInterest}
                  fullWidth={true}
                  label="Interest"
                />
                <br />
                <CurrencyFormater
                  value={this.state.Penalty}
                  onChange={this.changePenalty}
                  fullWidth={true}
                  label="Penalty"
                />
                <br />
                <CurrencyFormater
                  value={this.state.TotalRemainingPrincipal}
                  onChange={this.changeTotalRemainingPrincipal}
                  fullWidth={true}
                  label="Total remaining principal"
                />
                <br />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.CreditEnded}
                      onClick={this.changeCreditEnded}
                    />
                  }
                  label="Credit ended"
                />
              </CardContent>
              <CardActions>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.registerPayment}
                >
                  Register
                </Button>
              </CardActions>
            </Card>
          </div>
        </div>
      </div>
    );
  }

  openInfoDialog = () => {
    this.setState({ isDialogOpen: true });
  };

  closeInfoDialog = () => {
    this.setState({ isDialogOpen: false });
  };

  changePaymentId = (event) => {
    this.setState({
      PaymentId: event.target.value,
    });
  };

  changeTotalRemainingPrincipal = (event) => {
    this.setState({
      TotalRemainingPrincipal: event.target.value.replace(",", "."),
    });
  };

  changePrincipal = (event) => {
    this.setState({
      Principal: event.target.value.replace(",", "."),
    });
  };

  changeInterest = (event) => {
    this.setState({
      Interest: event.target.value.replace(",", "."),
    });
  };

  changeNumber = (event) => {
    this.setState({
      Number: event.target.value,
    });
  };
  changePenalty = (event) => {
    this.setState({
      Penalty: event.target.value.replace(",", "."),
    });
  };

  changeOriginatorCreditId = (event) => {
    this.setState({
      OriginatorCreditId: event.target.value,
    });
  };

  changeBankReceiveDate = (value) => {
    this.setState({
      BankReceiveDate: value,
    });
  };

  changeOriginator = (event) => {
    this.setState({
      OriginatorId: event.target.value,
    });
  };

  changeCreditEnded = () => {
    this.setState({
      CreditEnded: !this.state.CreditEnded,
    });
  };

  static propTypes = {
    accounting: PropTypes.any,
    registerMPLRepayment: PropTypes.func,
  };
}

export default compose(accountingConnector)(
  AccountingRegisteringMarketplaceComponent,
);
